// Synthetic zones for the 17 May case study and its home-page card. None of this is
// measured. It is an even hexagonal grid over central Oslo: centres 1 km apart,
// `radius` 500 m (vertex to centre), placed so no centre sits on a named landmark
// (every centre is at least 280 m from Karl Johans gate, 420 m from Slottet, 550 m
// from Frognerparken and 640 m from Rådhusplassen) and no zone lies mostly over the
// fjord. `level` is a made-up
// relative activity in four coarse steps (0.25, 0.5, 0.75, 1), strongest in the
// middle of the grid and weaker towards the edges.
export const may17SyntheticZones = [
  // southern row (east of the harbour)
  { position: [10.7468, 59.9091], radius: 500, level: 0.75 },
  { position: [10.7647, 59.9091], radius: 500, level: 0.75 },
  { position: [10.7826, 59.9091], radius: 500, level: 0.5 },
  // second row
  { position: [10.702, 59.9169], radius: 500, level: 0.5 },
  { position: [10.7199, 59.9169], radius: 500, level: 0.75 },
  { position: [10.7378, 59.9169], radius: 500, level: 1 },
  { position: [10.7558, 59.9169], radius: 500, level: 1 },
  { position: [10.7737, 59.9169], radius: 500, level: 0.75 },
  { position: [10.7916, 59.9169], radius: 500, level: 0.5 },
  // third row
  { position: [10.7109, 59.9247], radius: 500, level: 0.5 },
  { position: [10.7289, 59.9247], radius: 500, level: 0.75 },
  { position: [10.7468, 59.9247], radius: 500, level: 1 },
  { position: [10.7647, 59.9247], radius: 500, level: 0.75 },
  { position: [10.7826, 59.9247], radius: 500, level: 0.5 },
  // northern row
  { position: [10.702, 59.9325], radius: 500, level: 0.25 },
  { position: [10.7199, 59.9325], radius: 500, level: 0.5 },
  { position: [10.7378, 59.9325], radius: 500, level: 0.75 },
  { position: [10.7558, 59.9325], radius: 500, level: 0.75 },
  { position: [10.7737, 59.9325], radius: 500, level: 0.5 },
  { position: [10.7916, 59.9325], radius: 500, level: 0.25 },
];
